module.exports = __webpack_public_path__ + "img/wrench.b7d1cec3.svg";